//* Libraries imports
import z from "zod";

/**
 * Validates DatetimeService attributes, like createdAt or updatedAt.
 * 
 * @example
 * const date = {
    "slug": "2024-07-23 13:32:34",
    "human": {
      "date": "23\/07\/2024",
      "time": "13:32"
    }
 * } // Valid
 * const date = "01/01/2000" // Invalid
 */
export const dateFormat = z.object({
  slug: z.string(),
  human: z.object({
    date: z.string(),
    time: z.string(),
  }),
});
